// Iter 63 — the chat page reads a prepared question (never auto-sent) and a workspace from the URL.
import { COMPARE_QUESTION_PARAM, COMPARE_WORKSPACE_PARAM } from "@/lib/compareSelection";

/** { question, workspaceId } from ?q=&ws= (null fields when absent / blank). */
export function readChatPrefill(searchParams) {
  const get = (k) => (searchParams && typeof searchParams.get === "function" ? searchParams.get(k) : null);
  const question = (get(COMPARE_QUESTION_PARAM) || "").trim();
  const workspaceId = (get(COMPARE_WORKSPACE_PARAM) || "").trim();
  if (!question && !workspaceId) return null;
  return { question: question || null, workspaceId: workspaceId || null };
}

export function prefillNoteText(workspaceName) {
  const where = workspaceName ? `workspace "${workspaceName}"` : "the selected workspace";
  return `Comparison question prepared from ${where} — review it, then press Send. Nothing has been sent yet.`;
}
